import React from 'react'
import styled, { css } from 'styled-components'
import { SH1, SH4, STypographyDesc } from '@components/Typography'
import Box from '@components/Box'
import Container from '@components/Container'
import { above, below } from '@styles/mixins/breakpoints'
import { copyright, marks } from './data'
import Menu from './Menu'
import FormBlock from '@components/FormBlock'
import ImageLime from '@images/lime-frame.png'
import Man from '@images/rain.png'
import SButton from '@components/Button'

export const Ssection = styled(Box)`
  margin: 32px auto;
  padding: 0 20px;
  max-width: 1220px;

  ${above('sm')(css`
    margin: 56px auto;
  `)}
`

const Sblock = styled(Box)`
  display: flex;
  justify-content: space-between;
  background-color: #c6f4c6;
  overflow: hidden;
  background-image: url(${ImageLime});
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: bottom;
  border-radius: 8px;

  ${below('md')(css`
    flex-direction: column;
    background-position-x: center;
    background-position-y: bottom;
    background-size: cover;
  `)}
`
const SBlockImg = styled(Box)`
  position: relative;
  right: 50px;

  ${below('md')(css`
    position: static;
  `)}
`

const SHeading = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  ${above('lg')(css`
    margin-bottom: 40px;
  `)}
`

const SDescr = styled(Box)`
  margin-bottom: 20px;
  font-size: 13px;
  line-height: 20px;
  color: #2c3136;

  ${above('lg')(css`
    max-width: 600px;
    font-weight: 400;
    font-size: 17px;
    line-height: 26px;
    margin-bottom: 40px;
  `)}
`

const SBoxText = styled(Box)`
  padding: 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${above('md')(css`
    padding: 60px;
  `)}
`

const SImg = styled.img`
  height: 100%;

  ${below('md')(css`
    position: relative;
    top: 1px;
    width: 100%;
    height: auto;
  `)}
`

const SHeadTitle = styled(SH1)`
  font-family: 'SB Sans Interface', Arial, 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 0;

  ${above('lg')(css`
    font-size: 36px;
    line-height: 44px;
  `)}
`

const SLinkButton = styled(SButton)`
  display: initial;

  ${below('lg')(css`
    display: inherit;
    padding: 10px 15px;
  `)}
  ${below('md')(css`
    display: none;
  `)}
`
const SLinkMobButton = styled(SButton)`
  text-align: center;
  display: none;

  ${below('md')(css`
    display: block;
  `)}
`

const BannerToFooter: React.FC = () => (
  <Ssection>
    <Sblock>
      <SBoxText>
        <SHeading>
          <SHeadTitle>Программа для самозанятых</SHeadTitle>
        </SHeading>
        <SDescr>Формируйте свою пенсию самостоятельно с помощью индивидуального пенсионного плана</SDescr>
        <Box>
          <SLinkButton
            text="Посмотреть условия"
            href="https://npfsberbanka.ru/lp/ipp/selfemployed/?utm_source=sbernpfsite&utm_medium=banner&utm_campaign=szpromo&utm_content=mbpage"
            link
            target="_blank"
          />
        </Box>
      </SBoxText>
      <SBlockImg>
        <SImg src={Man} alt="man-with-bread" />
      </SBlockImg>
      <Box>
        <SLinkMobButton
          text="Посмотреть условия"
          href="https://npfsberbanka.ru/lp/ipp/selfemployed/?utm_source=sbernpfsite&utm_medium=banner&utm_campaign=szpromo&utm_content=mbpage"
          link
          target="_blank"
        />
      </Box>
    </Sblock>
  </Ssection>
)

export default BannerToFooter
